import { render, staticRenderFns } from "./CompanyBar.vue?vue&type=template&id=4a52dd28&scoped=true&"
import script from "./CompanyBar.vue?vue&type=script&lang=js&"
export * from "./CompanyBar.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBar.vue?vue&type=style&index=0&id=4a52dd28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a52dd28",
  null
  
)

export default component.exports